import LineIcon from '@/components/Icon/lineIcon';
import * as S from './style';
import { useLocation, useNavigate } from 'react-router-dom';
import { Newsletter } from '@/api/notice';
import dayjs from 'dayjs';
interface ConferenceListProps {
	data: (Newsletter)[];
	sort: string;
}
const ConferenceList = ({ data, sort }: ConferenceListProps) => {
	const navigate = useNavigate();
	const location = useLocation();
	const params = location.state?.menu ?? '소식지';
	const getDynamicField = (g: any, field: string) => g[`${sort}_${field}`] || ''; // 동적으로 필드 처리
	const handleGetPk = (pk: number | string) => {
		if (sort === 'guide') {
			navigate(`/conference/detail/${pk}`, { state: { menu: params } });
			return;
		}
		navigate(`/infoplace/detail/${pk}`, { state: { menu: params } });
	};
	return (
		<S.NoticeList>
			{data.map((item) => (
				<S.NoticeListItem key={getDynamicField(item, 'pk')} onClick={() => handleGetPk(getDynamicField(item, 'pk'))}>
					<div className="title">{getDynamicField(item, 'title')}</div>
					<div className="sub_title">
						{getDynamicField(item, 'enrollment_date') === '' ? '-' : dayjs(getDynamicField(item, 'enrollment_date')).format('YYYY-MM-DD')}
						<LineIcon />
						조회수: {getDynamicField(item, 'hit') === '' ? '0' : getDynamicField(item, 'hit')}
					</div>
				</S.NoticeListItem>
			))}
		</S.NoticeList>
	);
};
export default ConferenceList;
